
import React from 'react';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom'
import './header.css'
import { MDBIcon} from "mdbreact";
import Avatar from '@material-ui/core/Avatar';
import { SearchOutlined,DownOutlined  } from '@ant-design/icons';
import { Input} from 'antd';
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { MDBDropdown, MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem,MDBBadge/*,MDBBtn*/ } from "mdbreact";
import {hasValue} from '../../validations/validations'
import {message} from 'antd';
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { setUser } from "../../redux/actions/AuthActions";
import {getUnseenMessagesCount} from '../../redux/actions/ChatAction'
import {getNotifications,getUnreadNotificationsCount} from '../../redux/actions/NotificationAction'
import 'antd/dist/antd.css';


class Header extends React.Component {
  constructor(props){
    super(props)
    console.log("isr   ",this.props.isRTL)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    } 
  }

  state ={
    isLogin:true,
    query:{},
    value:'',
    searchOpen: false,
    hoveringSearch: false,
    inputFocused: false
    
  }

  componentDidMount(){
    this.props.getNotifications(1,true,this.props.currentUser.token)
    this.props.getUnreadNotificationsCount(this.props.currentUser.token)
  }
 
  readNotification = (notID) => {
    console.log(notID)
    axios.put(`${BASE_END_POINT}notif/${notID}/read`,{}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`
      },
    }).then(Response=>{
        console.log("notification is red")
        this.props.getNotifications(1,true,this.props.currentUser.token)
        console.log(Response)
    }).catch(error=>{
        console.log(error.response)
    })
  }
  // Open search (called on hover or click)
  openSearch = (focus = false) => {
    this.setState({ searchOpen: true }, () => {
      if (focus && this.searchInput && typeof this.searchInput.focus === 'function') {
        // Antd Input has focus() API
        this.searchInput.focus();
      }
    });
  }

  // Close search only if not hovering and not focused
  tryCloseSearch = () => {
    const { hoveringSearch, inputFocused } = this.state;
    if (!hoveringSearch && !inputFocused) {
      this.setState({ searchOpen: false });
    }
  }

  // toggle by click (useful for mobile)
  toggleSearch = () => {
    this.setState(prev => {
      const next = !prev.searchOpen;
      return { searchOpen: next };
    }, () => {
      if (this.state.searchOpen && this.searchInput && typeof this.searchInput.focus === 'function') {
        this.searchInput.focus();
      }
    });
  }

  // handle enter press (same logic as original)
  handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      if(hasValue(""+e.target.value)){
        const data = {
          ...this.state.query,
          search:e.target.value,
          index:-1,
          fromHome:true,
        }
        this.setState({query:data,value:'', searchOpen:false})
        this.props.history.push("/Search",{data:data})
      }else{
        message.warning(allStrings.noValue);
      }
    }
  }

  


  render(){
        const { value, searchOpen } = this.state;

  return (
    <div  style={{width:'100%',background:'transparent'}}>
      <nav className="navbar navbar-expand-lg navbar-light " style={{background:'transparent',color:'#fff'}}>
        {/* <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button> */}

        <div className="navbar navbar-expand" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto ">
            <li></li>
          <li className="nav-item active searchUI">
            <div
              className={`search-wrapper ${searchOpen ? 'open' : ''}`}
              onMouseEnter={() => { this.setState({ hoveringSearch: true }); this.openSearch(false); }}
              onMouseLeave={() => { this.setState({ hoveringSearch: false }); setTimeout(() => this.tryCloseSearch(), 120); }}
            >
              {/* icon always visible */}
              <div
                className="search-icon"
                onClick={(ev) => { ev.stopPropagation(); this.toggleSearch(); }}
                title={allStrings.SearchAbout}
              >
                <SearchOutlined />
              </div>

              {/* input expands when searchOpen === true */}
              <Input
                ref={el => this.searchInput = el}
                className={`search-input ${this.state.inputFocused ? 'focused' : ''}`}
                value={this.state.value}
                onChange={(e) => this.setState({ value: e.target.value })}
                onKeyPress={this.handleKeyPress}
                placeholder={allStrings.SearchAbout}
                size="large"
                allowClear
                onFocus={() => this.setState({ inputFocused: true })}
                onBlur={() => { this.setState({ inputFocused: false }); setTimeout(() => this.tryCloseSearch(), 120); }}
              />
            </div>
          </li>
          <li></li>
          </ul>
          <ul className="navbar-nav mr-auto rightUl">

          {this.props.currentUser&&
          <li className="nav-item hasProfile">
            <MDBDropdown>
              <MDBDropdownToggle color="transparent" caret className="customColor-text d-flex align-items-center">
                <Avatar
                  alt="Remy Sharp"
                  src={
                    this.props.currentUser
                      ? this.props.currentUser.user.img
                      : require("../../assets/images/logo.png")
                  }
                  style={{ marginLeft: "0px" }}
                />
                <span
                  className="headerUsername"
                  style={{
                    float: "left",
                    padding: "1px 2px",
                    minWidth: "50px",
                    textAlign: "right",
                  }}
                >
                  {this.props.currentUser ? this.props.currentUser.user.fullname : " "}
                </span>
                <DownOutlined style={{ marginRight: "0px" }} />

                
              </MDBDropdownToggle>

              <MDBDropdownMenu basic>
                <MDBDropdownItem
                  style={{ fontSize: "14px", color: "rgb(82, 86, 89)" }}
                  onClick={() => {
                    this.props.history.push("/userInfo", {
                      data: this.props.currentUser.user,
                    });
                  }}
                >
                  {allStrings.Profile}
                </MDBDropdownItem>

                <MDBDropdownItem
                  onClick={() => {
                    this.props.ChangeLanguage(true);
                    allStrings.setLanguage("ar");
                    localStorage.setItem("@LANG", "ar");
                  }}
                >
                  عربى
                </MDBDropdownItem>

                <MDBDropdownItem
                  onClick={() => {
                    this.props.ChangeLanguage(false);
                    allStrings.setLanguage("en");
                    localStorage.setItem("@LANG", "en");
                  }}
                >
                  English
                </MDBDropdownItem>

                <MDBDropdownItem divider />

                <MDBDropdownItem
                  onClick={() => {
                    localStorage.removeItem("@USERSAAEI");
                    this.props.history.replace("/Login");
                    this.props.setUser(null);
                  }}
                >
                  <img
                    alt=""
                    style={{
                      width: "15px",
                      marginRight: "5px",
                    }}
                    src="https://res.cloudinary.com/dcsy8vdyz/image/upload/v1590391199/golkfoust6bcelmypcjo.svg"
                  />
                  {allStrings.logout}
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
          </li>
          }
          <li className="nav-item nav-item-icon notifs">
          {this.props.currentUser&&
          <MDBDropdown>
            <MDBDropdownToggle color={'transparent'} caret className={'balck-text'}>
              
            <MDBIcon icon="bell" className={'customColor-text'} />
            <MDBBadge style={{background: 'linear-gradient(135deg, #FF3547, #B71C1C)',color:'#fff'}} color ="FF3547" className="ml-2">
            {this.props.unreadNotifCount > 99 ? '9+' : this.props.unreadNotifCount}
            </MDBBadge>
                    
            </MDBDropdownToggle>
            <MDBDropdownMenu basic flip>
              {this.props.notifications.map(noti=>(
            <MDBDropdownItem key={noti.id} onClick={()=>{
                if(!noti.read){
                  this.readNotification(noti.id)
                  this.props.getUnreadNotificationsCount(this.props.currentUser.token)
                  
                }
            }} style={{fontSize: '14px',color:' rgb(82, 86, 89)'}}>
              <div
                className="notif"
                style={{
                  borderRadius: "10px",
                  background: noti.read ? "#fefefe" : "#f5fafa",
                  boxShadow: noti.read ? "0 2px 6px rgba(0,0,0,0.08)":"none",
                  padding: "10px",
                  marginBottom: "8px",
                  display: "flex",
                  alignItems: "flex-start",
                  transition: "all 0.3s ease"
                }}
              >
                <div className="personPic" style={{ marginRight: "10px" }}>
                  <Avatar
                    alt="Remy Sharp"
                    src={noti.img ? noti.img : require("../../assets/images/logo.png")}
                    />
                  </div>
                  <div className="notifData">
                    <p
                      style={{
                        fontWeight: "500",
                        fontSize: "13px",
                        marginBottom: "4px",
                        color: "#333"
                      }}
                    >
                      {this.props.isRTL ? noti.title : noti.title}
                      
                    </p>
                    <p style={{ color: "#666", fontSize: "12px", lineHeight: "1.4" }}>
                      {this.props.isRTL ? noti.description : noti.description}
                    </p>
                    <span
                        style={{
                          color: "#999",
                          float: "right",
                          fontWeight: "300",
                          fontSize: "10px"
                        }}
                      >
                        {"" + new Date(noti.createdAt).toLocaleDateString()}
                    </span>
                  </div>
                </div>

              </MDBDropdownItem>
            ))}
            <p style={{
                textAlign: 'center',
                lineHeight: 'initial',
                paddingTop: '10px',
                marginBottom: '0px',
                color: 'blue'
            }}>more</p>
            </MDBDropdownMenu>
          </MDBDropdown>
          }
          </li>
          <li></li>
          </ul>
        </div>
      </nav>
    </div> 
  )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
  unseenMsgCount: state.chat.unseenMsgCount,
  notifications: state.notif.notifications,
  notifPage: state.notif.notifPage,
  notifPages: state.notif.notifPages,
  unreadNotifCount: state.notif.unreadNotifCount
})

const mapDispatchToProps = {
  ChangeLanguage,
  setUser,
  getUnseenMessagesCount,
  getUnreadNotificationsCount,
  getNotifications,
}

export default  withRouter(
  connect(mapToStateProps,mapDispatchToProps)(Header)
);
